import * as React from 'react';
import { CompanyDocument } from '../../containers_v2/client-companies/model/Model';
import NewDocument from '../../containers_v2/client-companies/popup/NewDocument';
import { PopupMode } from '../popup/model/Model';
import Popup from '../popup/Popup';
import { LinkedElementId } from '../../containers/companies/components/linkedElements/actions';

function DocumentCreation(props: {
	isOpen: boolean
	setOpen: (value: boolean) => void
	onCreate?: (values: CompanyDocument[]) => void
	id?: LinkedElementId
	maxDocument?: number
}): JSX.Element {
	function close(): void {
		props.setOpen(false);
	}

	return (
		<Popup
			isOpen={props.isOpen}
			onClickOut={() => close()}
			popupStyle={{ animate: true, top: '0%' }}
			popupMode={PopupMode.Details}
			content={<NewDocument
				onClickOut={() => close()}
				onCreate={(values) => {
					props.onCreate?.(values);
					close();
				}}
				id={props.id}
				maxDocument={props.maxDocument}
			/>}
		/>
	);
}

export default DocumentCreation;
